import { c as _c } from "react/compiler-runtime";
import Typography from '@classify/react-core-components/Typography';
import Stack from '@classify/react-core-components/Stack';
import { styled } from '@classify/react-core-components/styles';
import ROUTES from '@openclassrooms/routing/routes';
import Image from 'next/image';
import type { CourseCreator } from '@openclassrooms/sdk-web';
import isAllowedUrl from '@/modules/image/isAllowedUrl';
interface CourseCreatorsProps {
  creators: Array<CourseCreator>;
}
const CreatorsContent = styled(Stack)(({
  theme: {
    spacing,
    breakpoints
  }
}) => ({
  '&:not(:first-of-type)': {
    marginTop: spacing(4),
    [breakpoints.up('sm')]: {
      marginTop: 0
    }
  },
  [breakpoints.up('sm')]: {
    marginTop: 0,
    marginRight: spacing(4)
  }
}));
const CourseCreators = t0 => {
  const $ = _c(4);
  const {
    creators
  } = t0;
  if (!creators || creators.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== creators) {
    t1 = creators.map(_temp);
    $[0] = creators;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <Stack direction="row" flexWrap="wrap" gap={2}>{t1}</Stack>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default CourseCreators;
function _temp(creator) {
  const imgProps = {
    src: creator.logo,
    alt: creator.name,
    width: 200,
    height: 200,
    style: {
      height: 56,
      width: "auto"
    }
  };
  const ImageComponent = isAllowedUrl(creator.logo) ? Image : "img";
  return <CreatorsContent direction="row" alignItems="center" key={creator.id} gap={2}><ImageComponent {...imgProps} /><Typography variant="h6" component="a" href={`${ROUTES.PARTNERS.INDEX}/${creator.id}`}>{creator.name}</Typography></CreatorsContent>;
}